module.exports = {"component":"carousel","status":"prototype","display-name":"Carousel","SLDS-component-path":"/components/carousel","url-slug":"carousel"}


//////////////////
// WEBPACK FOOTER
// ./components/carousel/docs.json
// module id = 235
// module chunks = 0